import Input from '@/components/General/inputs/Input';
import DatePickerInput from '@/components/General/inputs/DatePickerInput';

/**
 * CareDetailsFields — the spec §7.5 careDetails field set, shared by
 * StartCareSheet (intake) and EditCareDetailsSheet (in-place edits on an
 * active episode): location, locationInstructions, visitPreferences,
 * coordinationContact, deliveryInstructions, reviewDate. All optional;
 * none block submission.
 *
 * `values` carries trimmed-or-empty strings for the text fields and a
 * Date|null for reviewDate — callers normalize reviewDate to the stored
 * 'YYYY-MM-DD' form when building the careDetails/patch payloads.
 */
const CareDetailsFields = ({ values, onFieldChange, testIDPrefix = 'care-details', disabled = false }) => {
    const update = (key) => (value) => onFieldChange?.(key, value);
    return (
        <>
            <Input
                title="Location"
                placeholder="e.g. St. Mary's Hospital, Room 214"
                value={values?.location}
                maxLength={200}
                disabled={disabled}
                onUpdate={update('location')}
                testID={`${testIDPrefix}-location`}
            />
            <Input
                title="Location instructions (optional)"
                placeholder="e.g. Visitor check-in at the main desk"
                value={values?.locationInstructions}
                multiline
                disabled={disabled}
                onUpdate={update('locationInstructions')}
                testID={`${testIDPrefix}-location-instructions`}
            />
            <Input
                title="Visit preferences (optional)"
                placeholder="e.g. Short visits, afternoons only, no flowers"
                value={values?.visitPreferences}
                multiline
                disabled={disabled}
                onUpdate={update('visitPreferences')}
                testID={`${testIDPrefix}-visit-preferences`}
            />
            <Input
                title="Coordination contact (optional)"
                placeholder="e.g. Call Sarah before visiting"
                value={values?.coordinationContact}
                maxLength={200}
                disabled={disabled}
                onUpdate={update('coordinationContact')}
                testID={`${testIDPrefix}-coordination-contact`}
            />
            <Input
                title="Delivery instructions (optional)"
                placeholder="e.g. Leave meals in the cooler by the door"
                value={values?.deliveryInstructions}
                multiline
                disabled={disabled}
                onUpdate={update('deliveryInstructions')}
                testID={`${testIDPrefix}-delivery-instructions`}
            />
            <DatePickerInput
                title="Review date (optional)"
                mode="date"
                value={values?.reviewDate}
                disabled={disabled}
                onUpdate={update('reviewDate')}
            />
        </>
    );
};

export default CareDetailsFields;
